import React from 'react';

const PartnerItem = ({ name }: { name: string }) => (
  <div className="list-item min-w-0 grow xs-max:grow-0 text-center">
    <span className="text-[#002926] text-[16px] xl:text-[24px] font-semibold leading-[150%] tracking-[0.15px]">
      {name}
    </span>
  </div>
);

const DEFAULT_PARTNERS = ['BARMER', 'Techniker Krankenkasse', 'AOK', 'IKK classic'];

const PartnerLogos = ({
  title = 'Erstattet von über 40 Krankenkassen:',
  partners = DEFAULT_PARTNERS,
}: {
  title?: string;
  partners?: string[];
}) => {
  return (
    <div className="flyntComponent themeLightBlue collapseSpace componentNew" is="flynt-bar-logos">
      <div className="container centerMaxWidthContainer">
        <p className="list-title">{title}</p>
        <div className="list justify-between xs-max:!gap-3">
          {partners.map((name) => (
            <PartnerItem key={name} name={name} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnerLogos;
